import { Box, ListItem, ListItemText, Typography } from '@mui/material';
import React from 'react';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const LineItem = ({ label, value, ...rest }) => {
	const classes = useStyles();

	return (
		<ListItem {...rest}>
			<ListItemText
				primary={
					<Typography component="span" variant="body2">
						{label + ' '}
					</Typography>
				}
				secondary={
					<Typography component="span" variant="body1">
						{value ? value : '-'}
					</Typography>
				}
			/>
		</ListItem>
	);
};

export default LineItem;

const useStyles = makeStyles((theme) => ({
	root: {}
}));
